import type { ReceivePaymentRequest } from '@weft/api-definition';
import { useMutation, useQueryClient, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../services/api';
import { USE_INVOICES_OVERVIEWS_QUERY_KEY } from './requests/use-invoices-overviews/use-invoices-overviews-consts';

export function useReceivePayment(options?: UseMutationOptions<void, unknown, ReceivePaymentRequest>) {
  const queryClient = useQueryClient();

  return useMutation((receivePaymentRequest) => {
    const api = getPrivateApi();

    return api.receivePayment({ receivePaymentRequest });
  }, {
    onSuccess: async () => {
      await queryClient.invalidateQueries([USE_INVOICES_OVERVIEWS_QUERY_KEY]);
    },
    ...options,
  } );
}
